import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';

import { AtMentionContainerComponent } from './at-mention-container/at-mention-container.component';
import { AtMentionMenuComponent } from './at-mention-menu/at-mention-menu.component';
import { AtMentionDirective } from './at-mention.directive';
import { AtMentionService } from './at-mention.service';

@NgModule({
  declarations: [
    AtMentionDirective,
    AtMentionContainerComponent,
    AtMentionMenuComponent,
  ],
  imports: [CommonModule, MatMenuModule],
  exports: [
    AtMentionDirective,
    AtMentionContainerComponent,
    AtMentionMenuComponent,
  ],
  providers: [AtMentionService],
})
export class AtMentionModule {}
